<script>
import AppButton from './UI/AppButton.vue';
import { useDialogStore } from '../lib/dialog.js';

export default {
    name: 'ConfirmDialog',
    components: { AppButton },
    computed: {
        // Direct Pinia-store reference — same pattern useUiStore /
        // useSettingsStore use elsewhere. The template's `s.X` reads stay
        // unchanged since Pinia stores expose state fields as properties.
        s() { return useDialogStore(); },
    },
    methods: {
        confirm() { this.s.resolve(true); },
        cancel()  { this.s.resolve(false); },
        onKey(e) {
            if (!this.s.open) return;
            if (e.key === 'Escape') this.cancel();
            if (e.key === 'Enter' && !e.target.matches('textarea')) this.confirm();
        },
    },
    mounted() { document.addEventListener('keydown', this.onKey); },
    beforeUnmount() { document.removeEventListener('keydown', this.onKey); },
};
</script>

<template>
    <!-- Teleported to <body> so its z-[110] sits in the top-level stacking
         context — otherwise an open AppModal (Headless UI dialog, portalled to
         body at z-50) renders ABOVE this overlay and swallows the clicks. Every
         other escaping overlay (drawer, popover, tooltip) teleports for the
         same reason; this one didn't, which made confirms-over-a-modal dead. -->
    <Teleport to="body">
        <transition name="fade">
            <div v-if="s.open" class="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-ink/30">
                <div class="w-full max-w-md rounded-lg border border-line bg-surface shadow-pop">
                    <div class="px-5 pt-5 pb-3">
                        <h3 class="text-lg font-medium tracking-tight">{{ s.title }}</h3>
                        <p v-if="s.message" class="mt-1 text-sm text-ink-muted whitespace-pre-wrap">{{ s.message }}</p>
                    </div>
                    <div class="flex justify-end gap-2 border-t border-line bg-bg/40 px-5 py-3 rounded-b-lg">
                        <AppButton variant="secondary" @click="cancel">{{ s.cancelLabel }}</AppButton>
                        <AppButton :variant="s.danger ? 'danger' : 'primary'" @click="confirm">{{ s.confirmLabel }}</AppButton>
                    </div>
                </div>
            </div>
        </transition>
    </Teleport>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity 150ms ease-out; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>
